import * as calculatorConfig from '@/config/base-config.json';
import { generateSliderSteps } from '@/utils/generateSliderSteps';

export const OTHERS_EQUITY_TERM_LOAN_LABEL = {
  EquityDetails: 'Equity Details',
  EstimatedMVP: 'Estimated Market Valuation Price',
  PropertyType: 'Property Type',
  GearingRatio: 'Gearing Ratio',
  OutstandingLoan: 'Outstanding Loan',
  CPFUsed: 'CPF Used',
  CPFAccruedInterest: 'CPF Accrued Interest',
  MaximumEquityLoan: 'Maximum Equity Loan',
  SubjectToTDSRCompliance: 'Subject to TDSR Compliance',
  MaximumEquityLoanDisclaimer:
    "Note: Banks Are Prohibited by MAS From Granting A Home Equity Loan (or Similar Products) for The Borrower's Purchase of Residential Property.",
};

export enum EquityTermLoanPropertyType {
  RESIDENTIAL = 'Residential',
  NON_RESIDENTIAL = 'Non-Residential',
}

export const RESIDENTIAL_GEARING_RATIO = {
  MAX: calculatorConfig.gearing_ratio_in_percent.residential.max,
  MIN: calculatorConfig.gearing_ratio_in_percent.residential.min,
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.gearing_ratio_in_percent.residential.min,
    calculatorConfig.gearing_ratio_in_percent.residential.max,
    15,
  ),
  STEP: 1,
  DEFAULT: calculatorConfig.gearing_ratio_in_percent.residential.default,
};

export const NON_RESIDENTIAL_GEARING_RATIO = {
  MAX: calculatorConfig.gearing_ratio_in_percent.non_residential.max,
  MIN: calculatorConfig.gearing_ratio_in_percent.non_residential.min,
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.gearing_ratio_in_percent.non_residential.min,
    calculatorConfig.gearing_ratio_in_percent.non_residential.max,
    15,
  ),
  STEP: 1,
  DEFAULT: calculatorConfig.gearing_ratio_in_percent.non_residential.default,
};
